import React from 'react'
import {
  Dialog,
  DialogTitle,
  DialogContent,
  Stack,
  Typography,
  DialogActions,
  Button,
  Chip,
} from '@mui/material'
import { useTranslation } from 'react-i18next'

interface Props {
  onClose: () => void
  open: boolean
  data?: {
    [key: string]: string
  }
}

function StatsDialog(props: Props) {
  const { onClose, open, data } = props
  const { t } = useTranslation()
  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle id="alert-dialog-title" sx={{ fontWeight: 'bolder' }}>
        {t('statistics.title')}
      </DialogTitle>
      <DialogContent>
        <Stack>
          <table>
            <tr>
              <td>
                <Typography variant="body1">
                  {t('statistics.active')} :{' '}
                </Typography>
              </td>
              <td>
                <Chip color="success" label={data?.['ACTIVE']} />
              </td>
            </tr>
            <tr>
              <td>
                <Typography variant="body1">
                  {t('statistics.inactive')} :{' '}
                </Typography>
              </td>
              <td>
                <Chip color="primary" label={data?.['INACTIVE']} />
              </td>
            </tr>
            <tr>
              <td>
                <Typography variant="body1">
                  {t('statistics.deleted')} :{' '}
                </Typography>
              </td>
              <td>
                <Chip color="error" label={data?.['DELETED']} />
              </td>
            </tr>
            <tr>
              <td>
                <Typography variant="body1">
                  {t('statistics.invalid')} :{' '}
                </Typography>
              </td>
              <td>
                <Chip color="warning" label={data?.['INVALID']} />
              </td>
            </tr>
            <tr style={{ borderTop: '1px solid black' }}>
              <td>
                <Typography variant="body1">
                  {t('statistics.total')} :{' '}
                </Typography>
              </td>
              <td>
                <Chip
                  color="info"
                  label={
                    data
                      ? data?.['ACTIVE'] +
                        data?.['INACTIVE'] +
                        data?.['DELETED'] +
                        data?.['INVALID']
                      : 0
                  }
                />
              </td>
            </tr>
          </table>
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>{t('statistics.closeButton')}</Button>
      </DialogActions>
    </Dialog>
  )
}

export default StatsDialog
